export const addProductVulcan = 'addProductVulcan';

export const customerInformationFieldNames = [addProductVulcan];
